/**
 * Which direction the radio button group arranges its children.
 */
export var RadioButtonGroupDirection;
(function (RadioButtonGroupDirection) {
    RadioButtonGroupDirection[RadioButtonGroupDirection["Horizontal"] = 1] = "Horizontal";
    RadioButtonGroupDirection[RadioButtonGroupDirection["Vertical"] = 2] = "Vertical";
})(RadioButtonGroupDirection || (RadioButtonGroupDirection = {}));
